import React, { useEffect, useRef, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getInvoices } from "../helpers/Invoices";
import { Link } from "react-router-dom";
import { format } from "../helpers/Currency";
import Pagination from "../components/Pagination";
import { getProducts } from "../helpers/Products";
import { getAttributes } from "../helpers/Attributes";


export default function Attributes() {
    const { appState } = useAppState();
    const [attributes, setAttributes] = useState<Array<any>>([])
    const [search, setSearch] = useState<string | null>(null)
    const [page, setPage] = useState<number>(1)
    const [meta, setMeta] = useState<any>({
        page: 1,
        totalPages: 1,
    });
    const abortController = useRef<AbortController>();

    useEffect(() => {
        if (abortController.current) {
            abortController.current.abort()
        }
        abortController.current = new AbortController();
        getAttributes(10, page, search, { signal: abortController.current.signal }).then((result) => {
            setAttributes(result.data)
            setMeta({
                page: result.current_page,
                totalPages: result.last_page,
            })
        })
    }, [page, search])

    useEffect(() => {
        setPage(1);
    }, [search])

    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-xl">Attributes</h1>
                    <input onChange={(event) => { setSearch(event.target.value) }}></input>
                </div>
                <Link to="/attributes/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create attribute</Link>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <table className="w-full">
                    <thead className="text-left">
                        <tr className="border-b-1">
                            <th className="p-2">Id</th>
                            <th className="p-2">Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attributes.map((attribute: any) => {
                            return (
                                <tr className="border-b-1 border-gray-300">
                                    <td className="p-2">
                                        <Link to={`/attributes/${attribute.id}`}>{attribute.id}</Link>
                                    </td>
                                    <td className="p-2">{attribute.name}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div >
            {attributes && attributes.length > 0 ? (
                <div className="w-full mt-5">
                    <Pagination page={meta.page} totalPages={meta.totalPages} onCallback={setPage} />
                </div>
            ) : null
            }

        </>
    );
}
